import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import RequestHandler from "util/RequestHandler";
import InvoiceSubscriptionAdd from "../Forms/InvoiceSubscriptionAddForm";
import InvoiceSubscriptionUpdate from "../Forms/InvoiceSubscriptionUpdateForm";
import InvoiceSubscriptionTableFilter from "../Filters/InvoiceSubscriptionTableFilter";
import { odata, queryHelper } from "../Filters/Helper";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  notification,
  Select,
  Tooltip,
  Popconfirm,
  Drawer,
} from "antd";
import {
  QuestionCircleOutlined,
  OrderedListOutlined,
  WarningOutlined,
  PlusOutlined,
  EditOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import { ColumnHelper } from "util/TableHelper";
const { Option } = Select;

const InvoiceSubscriptionList = (props) => {
  const [options, setOptions] = useState({ pageTitle: "ABONELİKLER" });
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1580px)",
  });
  const [invoiceSubscriptions, setInvoiceSubscriptions] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [invoiceSubscriptionId, setInvoiceSubscriptionId] = useState("");
  const [visibleUpdate, setVisibleUpdate] = useState(false);
  const [visibleSubscriptionAdd, setVisibleSubscriptionAdd] = useState(false);
  const [dataState, setDataState] = useState([{ skip: 0, take: 20 }]);
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [name, setName] = useState("");
  const [product, setProduct] = useState("");
  const [productType, setProductType] = useState("");
  const [subscriberNo, setSubscriberNo] = useState("");
  const [productTypeId, setProductTypeId] = useState("");
  const [productTypes, setProductTypes] = useState({
    data: [],
    loading: true,
  });
  const errorList = [];
  const [updateFormData, setUpdateFormData] = useState({});
  const errorListNotification = (type) => {
    errorList.map((item) => {
      notification[type]({
        message: "Hata",
        description: item,
        duration: 2,
      });
    });
  };

  const openNotificationCheckWithIcon = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description:
        "Güncel borç sorgulama emri başarılı.Tüm aboneliklerinizin borç bilgisinin güncellenmesi 1-2 dakika sürebilir.",
      duration: 2,
    });
  };
  const history = useHistory();

  useEffect(() => {
    RequestHandler.get(`/Invoice/GetProductTypes`, false, {
      rawResponse: true,
    }).then((response) => {
      if (response.status == 200) {
        setProductTypes({
          data: response.data,
          loading: false,
        });
      }
    });
  }, []);

  useEffect(() => {
    getTableData();
  }, [tableDataQueryOptions]);

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Uyarı",
      description: "Pasif olan abonelikler güncellenemez.",
    });
  };

  const getTableData = () => {
    setInvoiceSubscriptions({
      ...invoiceSubscriptions,
      loading: true,
    });
    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    let query = "";
    const conditions = ["Name ne 'Diğer'"];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    RequestHandler.get(
      `/InvoiceSubscription?${query}${order} &$count=true&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setInvoiceSubscriptions({
        data: response.value,
        loading: false,
        total: response["@odata.count"],
      });
    });
  };

  const handleActivePassive = (id) => {
    RequestHandler.delete(`/InvoiceSubscription/${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const columns = [
    {
      title: "Ad",
      dataIndex: "name",
      key: "name",
      align: "left",
    },
    {
      title: "Kurum Tipi",
      dataIndex: "productType",
      key: "productType",
      align: "left",
    },
    {
      title: "Kurum Adı",
      dataIndex: "product",
      key: "product",
      align: "left",
    },
    {
      title: "Abone No",
      dataIndex: "subscriberNo",
      key: "subscriberNo",
      align: "left",
    },
    {
      title: "Güncel Borç",
      dataIndex: "currentDebtString",
      key: "currentDebtString",
      align: "left",
      render: (data, row) => {
        return row.currentDebt != null || row.currentDebt != 0 ? (
          data
        ) : (
          <Tooltip
            title={
              "Güncel borç bilgisi bulunmamaktadır.Hata olduğunu düşünüyorsanız, girdiğiniz bilgileri kontrol ediniz."
            }
          >
            <WarningOutlined style={{ color: "orange", fontSize: "130%" }} />
          </Tooltip>
        );
      },
    },
    {
      title: "Son Sorgulanma Tarihi",
      dataIndex: "lastQueryDate",
      key: "lastQueryDate",
      align: "center",
      render: (data) => {
        {
          return data != null ? (
            <div>
              {moment(data).format("L")} {moment(data).format("LT")}
            </div>
          ) : (
            ""
          );
        }
      },
    },
    {
      title: "Düzenle",
      dataIndex: "operation",
      align: "center",
      width: "5%",
      render: (text, record) =>
        invoiceSubscriptions.data.length >= 1 ? (
          record.isActive ? (
            <a
              onClick={() => {
                showDrawerUpdate(record.id);
              }}
              style={{
                color: "orange",
                fontSize: "130%",
                paddingBottom: "20px",
              }}
            >
              <EditOutlined />
            </a>
          ) : (
            <a
              onClick={() => {
                openNotificationWithIcon("warning");
              }}
              style={{
                color: "orange",
                fontSize: "130%",
                paddingBottom: "20px",
              }}
            >
              <EditOutlined />
            </a>
          )
        ) : null,
    },
    {
      title: "Durum",
      dataIndex: "operation",
      align: "center",
      render: (text, record) =>
        record.isActive ? (
          <Popconfirm
            title="Pasif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(record.id)}
          >
            <a style={{ color: "green", fontSize: "130%" }}>
              <CheckCircleOutlined />
            </a>
          </Popconfirm>
        ) : (
          <Popconfirm
            title="Aktif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(record.id)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <CloseCircleOutlined />
            </a>
          </Popconfirm>
        ),
    },
  ];

  const onCloseUpdate = () => {
    setVisibleUpdate(false);
  };
  const dataStateChange = (e) => {
    setInvoiceSubscriptions(e);
  };
  const onCloseAddSubscription = () => {
    setVisibleSubscriptionAdd(false);
  };

  const onUpdateSubscription = () => {
    getTableData();
    setVisibleUpdate(false);
  };

  const onAddSubscription = () => {
    getTableData();
    setVisibleSubscriptionAdd(false);
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const showDrawerUpdate = (value) => {
    RequestHandler.get(`/InvoiceSubscription/GetById/${value}`, false, {
      rawResponse: true,
    }).then((response) => {
      const newData = response.data;
      newData.productTypeId = productTypes.data.find(
        (x) => x.name == response.data.productType
      ).id;
      setUpdateFormData(newData);
      setVisibleUpdate(true);
    });
  };

  const checkAllInvoice = () => {
    setInvoiceSubscriptions({
      loading: true,
    });
    RequestHandler.post(`/Invoice/CheckAllInvoice`, [], false);
    openNotificationCheckWithIcon("success");
    setTimeout(
      function () {
        window.location.reload();
      }.bind(this),
      2000
    );
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
      };
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
        <Col
          xs={24}
          md={6}
          lg={isDesktopOrLaptop ? 6 : 5}
          style={{ textAlign: "right" }}
        >
          <Button
            type="primary"
            icon={<QuestionCircleOutlined />}
            htmlType="submit"
            onClick={checkAllInvoice}
            loading={invoiceSubscriptions.loading}
          >
            Güncel Borç Sorgula
          </Button>
        </Col>
        <Col
          xs={24}
          md={6}
          lg={isDesktopOrLaptop ? 2 : 3}
          style={{ textAlign: "right" }}
        >
          <Button
            type="primary"
            loading={invoiceSubscriptions.loading}
            onClick={() => setVisibleSubscriptionAdd(true)}
          >
            <PlusOutlined /> Abonelik Ekle
          </Button>
        </Col>
      </Row>
      <InvoiceSubscriptionTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            onChange={paging}
            dataSource={invoiceSubscriptions.data}
            loading={invoiceSubscriptions.loading}
            pageable={true}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: invoiceSubscriptions.total,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>
      <Drawer
        title="Abonelik Ekle"
        width={241}
        onClose={onCloseAddSubscription}
        visible={visibleSubscriptionAdd}
        bodyStyle={{ paddingBottom: 80 }}
        footer={<div style={{ textAlign: "right" }}></div>}
        destroyOnClose={true}
      >
        <InvoiceSubscriptionAdd onSuccess={onAddSubscription} />
      </Drawer>

      <Drawer
        title="Güncelle"
        width={241}
        onClose={onCloseUpdate}
        visible={visibleUpdate}
        bodyStyle={{ paddingBottom: 80 }}
        footer={<div style={{ textAlign: "right" }}></div>}
        destroyOnClose={true}
      >
        <InvoiceSubscriptionUpdate
          data={updateFormData}
          onSuccess={onUpdateSubscription}
        />
      </Drawer>
    </>
  );
};

export default InvoiceSubscriptionList;
